import { render } from "./ShForm.vue?vue&type=template&id=8bd680da&scoped=true"
import script from "./ShForm.vue?vue&type=script&lang=js"
export * from "./ShForm.vue?vue&type=script&lang=js"

import "./ShForm.vue?vue&type=style&index=0&id=8bd680da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bd680da"]])

export default __exports__